
import Swiper from 'swiper'
import ProductPageCard from '~/components/product/ProductPageCard.vue'
import 'swiper/css/swiper.min.css'
export default {
  name: 'RelatedProducts',
  props: ['id', 'lineItems'],
  components: { ProductPageCard },
  data() {
    return {
      relatedItems: new Set(),
      items: []
    }  
  },
  watch: {
    lineItems(){
      this.setRelatedItems()
      this.$nextTick(() => {
        this.initSwiper()
      });
    }
  },
  mounted(){
  },
  methods: {
    setRelatedItems(){
      this.relatedItems.clear()
      if (this.lineItems?.length) {
        this.lineItems.forEach((i) => {
          if (['SH00AA00'].includes(i.sku_code)) {
            this.relatedItems.add(JSON.stringify({ type: 'product_page', uid: 'eteria', filter: 'bundle' }))
            this.relatedItems.add(JSON.stringify({ type: 'product_page', uid: 'natede-basic' }))
          }
          if (['ET00AA00','ET00AA01','ET00AB00','ET00AB01','ET00AC00','ET00AC01'].includes(i.sku_code)) {
            this.relatedItems.add(JSON.stringify({ type: 'product_page', uid: 'shelfy' }))
            this.relatedItems.add(JSON.stringify({ type: 'product_page', uid: 'natede-smart' }))
          }
          if (['NT01AA02'].includes(i.sku_code)) {
            this.relatedItems.add(JSON.stringify({ type: 'product_page', uid: 'shelfy' }))
            this.relatedItems.add(JSON.stringify({ type: 'product_page', uid: 'eteria', filter: 'bundle' }))
          }
          if (['NT02AA00', 'NT02AA03', 'NT02AA04', 'NT02AA06'].includes(i.sku_code)) {
            this.relatedItems.add(JSON.stringify({ type: 'product_page', uid: 'shelfy' }))
            this.relatedItems.add(JSON.stringify({ type: 'product_page', uid: 'eteria', filter: 'bundle' }))
          }
        })
      } else {
        this.relatedItems.add(JSON.stringify({ type: 'product_page', uid: 'shelfy' }))
        this.relatedItems.add(JSON.stringify({ type: 'product_page', uid: 'natede-smart' }))
      }
      this.items = [...this.relatedItems].map(item => JSON.parse(item))
    },
    initSwiper() {
      this.swiper = new Swiper(`#${this.id} .swiper-container`, {
        slidesPerView: 1.5,
        spaceBetween: 20,
        loop: false,
        breakpoints: {
          1440: {
            slidesPerView: 2,
          },
          1280: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 2,
          },
          480: {
            slidesPerView: 1.5,
          },
        }
        // navigation: {
        //   nextEl: `#related-products .swiper-button-next`,
        //   prevEl: `#related-products .swiper-button-prev`,
        // },
        // pagination: {
        //   el: `#related-products .swiper-pagination`,
        //   clickable: true,
        // }
      })
    }
  }
}
